@let inactive = isSubscriptionInactive();

<div class="profile-panel" animate.enter="panel-enter">
  <header>
    <span class="title-medium">Profile</span>
    <button mat-icon-button (click)="onClose()">
      <mat-icon tfsIcon="x" />
    </button>
  </header>

  @if (!inactive) {
    <tfs-subscription-status></tfs-subscription-status>
    <tfs-assembly-quota-indicator></tfs-assembly-quota-indicator>
  }

  <mat-nav-list>
    <a
      mat-list-item
      [routerLink]="inactive ? null : '/account/settings'"
      [disabled]="inactive"
      [matTooltip]="inactiveTooltip"
      [matTooltipDisabled]="!inactive"
      matTooltipPosition="right"
      (click)="onSettingsClick()">
      <mat-icon matListItemIcon tfsIcon="gear-six" />
      <span>Account settings</span>
    </a>
    <button mat-list-item (click)="onLogout()">
      <mat-icon matListItemIcon tfsIcon="sign-out" />
      <span>Log out</span>
    </button>
  </mat-nav-list>
</div>
